(() => {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequirec4ac"];
var parcelRegister = parcelRequire.register;
parcelRegister("k7IeT", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $963d1c9525e421c4$export$2e2bcd8739ae039);

var $5uWxc = parcelRequire("5uWxc");

var $giM8N = parcelRequire("giM8N");

var $2MgeJ = parcelRequire("2MgeJ");

var $bTBLz = parcelRequire("bTBLz");

var $5GgJy = parcelRequire("5GgJy");

var $5Mkil = parcelRequire("5Mkil");

var $gpAW6 = parcelRequire("gpAW6");

var $gGPXq = parcelRequire("gGPXq");

var $7gWUw = parcelRequire("7gWUw");

var $ahcAq = parcelRequire("ahcAq");


var $2S7nZ = parcelRequire("2S7nZ");

var $e9qXa = parcelRequire("e9qXa");
const $963d1c9525e421c4$var$_SubwayGiveaway = ({ event: event })=>{
    if (event.otx_number === 15) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("a", {
        href: "https://overtime.box.com/s/44f9vt7g8jix5c43jxa7zihxn5qhqa96"
    }, "OTX x Subway Giveaway"));
    if (event.otx_number === 16) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("a", {
        href: "/public/Overtime-x-Subway-Giveaway-Rules-(9.18.25)-OTX-16.docx"
    }, "OTX x Subway Giveaway"));
    return null;
};
const $963d1c9525e421c4$var$_Info = ({ event: event })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "event-info"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "description"
    }, event.description ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("h2", null, "Info"), event.description?.split("\n\n").map((description, index)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("p", {
            key: index
        }, description);
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement($963d1c9525e421c4$var$_SubwayGiveaway, {
        event: event
    })) : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "venue"
    }, event.venue?.name && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("h2", null, "Venue"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "location"
    }, event.venue?.image_path && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "map"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $gpAW6.default), {
        src: `https://images.itsovertime.tv/${event.venue?.image_path}`,
        width: 320,
        mobileWidth: 160
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "address"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "name"
    }, event.venue?.name), event.venue?.address || event.address ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "city"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("img", {
        src: (0, $7gWUw.imgIconLocationPinSvg)
    }), event.venue?.city || event.city, ", ", event.venue?.state || event.state), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "street-address"
    }, event.venue?.street || event.street, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("br", null), event.venue?.city || event.city, ", ", event.venue?.state || event.state, " ", event.venue?.zip || event.zip), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "link"
    }, event.venue?.website_url ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("a", {
        href: event.venue.website_url
    }, "View Website ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $giM8N.FontAwesomeIcon), {
        icon: (0, $5uWxc.faArrowRight)
    })) : null)) : null)))));
};
const $963d1c9525e421c4$var$Event = ()=>{
    const { otx_event_id: otx_event_id } = (0, $bTBLz.useParams)();
    const event = (0, $ahcAq.default)({
        url: `${(0, $gGPXq.default).ApiEvents}/${otx_event_id}`,
        key: "otx_event"
    })?.result.read();
    const allFights = (0, $ahcAq.default)({
        url: (0, $gGPXq.default).ApiFights,
        key: "otx_fights"
    })?.result.read();
    const tournamentFights = (0, $ahcAq.default)({
        url: (0, $gGPXq.default).ApiTournamentFights,
        key: "otx_fights"
    }).result.read();
    if (!event) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $5Mkil.default), {
        title: event.title,
        className: "event-page"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $5GgJy.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $2S7nZ.default), {
        event: event
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement($963d1c9525e421c4$var$_Info, {
        event: event
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $e9qXa.default), {
        event: event,
        tournamentFights: tournamentFights
    })));
};
var // Note: There can only be one export per page component for hot loading to work
$963d1c9525e421c4$export$2e2bcd8739ae039 = $963d1c9525e421c4$var$Event;

});
parcelRegister("2S7nZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $31865dc76b454496$export$2e2bcd8739ae039);

var $275Aj = parcelRequire("275Aj");

var $2MgeJ = parcelRequire("2MgeJ");

var $ansEi = parcelRequire("ansEi");

var $gpAW6 = parcelRequire("gpAW6");

var $gGPXq = parcelRequire("gGPXq");

var $gbx5z = parcelRequire("gbx5z");

var $7gWUw = parcelRequire("7gWUw");

var $9mCP5 = parcelRequire("9mCP5");

var $cW5vC = parcelRequire("cW5vC");

var $87Ota = parcelRequire("87Ota");

const $31865dc76b454496$var$getVivenuEventIsSoldOut = (event)=>{
    const vivenuEvent = (0, $gbx5z.default)({
        url: `${(0, $gGPXq.default).ApiPlatformsVivenuEventInfo}/${event.vivenu_id}`,
        key: "event"
    })?.result.read();
    return vivenuEvent?.saleStatus === (0, $87Ota.SaleStatuses).SoldOut;
};
const $31865dc76b454496$var$Banner = ({ event: event })=>{
    const [fightDate, setFightDate] = (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).useState((0, $9mCP5.GetDateTimeString)(new Date(event.starts_at), "America/New_York"));
    (0, $2MgeJ.useEffect)(()=>{
        setFightDate((0, $9mCP5.GetDateTimeString)(new Date(event.starts_at), event.starts_at_timezone));
    }, [
        event.starts_at,
        event.starts_at_timezone
    ]);
    const isSoldOut = event.is_sold_out || $31865dc76b454496$var$getVivenuEventIsSoldOut(event);
    const mainEventFight = event?.otx_fights?.find((f)=>f.fight_type === (0, $cW5vC.FightTypes).MainEvent);
    const isOtxEvent = !!event.otx_number;
    const nextFight = (0, (/*@__PURE__*/$parcel$interopDefault($275Aj))).orderBy(event?.otx_fights, [
        (f)=>f.fight_type === (0, $cW5vC.FightTypes).MainEvent,
        (f)=>f.fight_type === (0, $cW5vC.FightTypes).CoMainEvent,
        (f)=>f.fight_type === (0, $cW5vC.FightTypes).Featured
    ], [
        "desc",
        "desc",
        "desc"
    ]).at(0);
    const fighter1 = nextFight?.otx_fighter1;
    const fighter2 = nextFight?.otx_fighter2;
    const isFightTbd = !fighter1 || !fighter2 || isOtxEvent && !mainEventFight;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "events-banner"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "hero-image"
    }, event.image_path ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $gpAW6.default), {
        src: `${(0, $gGPXq.default).OvertimeImagesOtx}/${event.image_path}`,
        mobileWidth: 750
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("img", {
        src: (0, $7gWUw.imgPlaceholdersKeyArtWebp)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "info"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $ansEi.default), {
        otxNumber: event.otx_number
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "fighters"
    }, event.is_custom_title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).Fragment, null, event.title) : isFightTbd ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).Fragment, null, "To be announced") : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).Fragment, null, fighter1.last_name, " vs ", fighter2.last_name)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "date"
    }, fightDate), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "highlights"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "highlight-icon"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("img", {
        src: (0, $7gWUw.imgIconStreamingSvg)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "highlight-text"
    }, event.id == "2ebe0296-1a1b-4601-8eba-c22aa4180010" ? "DAZN" : "DAZN, YouTube, TikTok, Instagram")), event.dj_name && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "highlight-icon"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("img", {
        src: (0, $7gWUw.imgIconHeadphonesSvg)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "highlight-text highlight-text--uppercase"
    }, event.dj_name)), event.is_18_plus ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "highlight-icon"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("img", {
        src: (0, $7gWUw.imgIcon18UpSvg)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "highlight-text"
    }, "18+ Only")) : null, event.is_alcohol_served ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "highlight-icon"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("img", {
        src: (0, $7gWUw.imgIconDrinkSvg)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "highlight-text"
    }, "Alcohol served")) : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "buttons"
    }, event.cta_url && event.cta_text && (0, $9mCP5.IsUpcoming)(event) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("a", {
        className: "cta primary",
        href: event.cta_url
    }, event.cta_text) : event.vivenu_id && !isSoldOut && (0, $9mCP5.IsUpcoming)(event) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("a", {
        className: "cta primary",
        href: event.vivenu_id ? `${(0, $gGPXq.default).VivenuEventBase}/${event.vivenu_id}` : null
    }, "Buy Tickets") : event.vivenu_id && isSoldOut && (0, $9mCP5.IsUpcoming)(event) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("a", {
        className: "cta",
        style: {
            cursor: "default"
        }
    }, "Sold Out") : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).Fragment, null), event.dazn_url && (0, $9mCP5.IsInProgress)(event) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("a", {
        className: "cta primary",
        href: event.dazn_url
    }, "Watch Live") : event.dazn_url && (0, $9mCP5.IsUpcoming)(event) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("a", {
        className: "cta secondary",
        href: event.dazn_url
    }, "Watch Live") : event.dazn_url && ((0, $9mCP5.HasAllFightResults)(event) || (0, $9mCP5.IsInPast)(event)) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("a", {
        className: "cta secondary",
        href: event.dazn_url
    }, "Replay") : null)));
};
var // Note: There can only be one export per page component for hot loading to work
$31865dc76b454496$export$2e2bcd8739ae039 = $31865dc76b454496$var$Banner;

});

parcelRegister("e9qXa", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3fff03f3fe765fb$export$2e2bcd8739ae039);

var $275Aj = parcelRequire("275Aj");

var $2MgeJ = parcelRequire("2MgeJ");

var $fRUpF = parcelRequire("fRUpF");

var $35OBH = parcelRequire("35OBH");

const $b3fff03f3fe765fb$var$FightCards = ({ event: event, tournamentFights: tournamentFights })=>{
    if (event.otx_fights.length > 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("section", {
        className: "events-fight-cards"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $35OBH.default), null, "Fight Card"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "cards"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($275Aj))).orderBy(event.otx_fights, (f)=>f.starts_at).reverse().map((fight)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $fRUpF.default), {
            key: fight.id,
            fight: fight,
            tournamentFights: tournamentFights
        }))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).Fragment, null);
};
var // Note: There can only be one export per page component for hot loading to work
$b3fff03f3fe765fb$export$2e2bcd8739ae039 = $b3fff03f3fe765fb$var$FightCards;

});


})();
//# sourceMappingURL=Event.6f2861d0.js.map
